import { useEffect, useState, useRef, useContext } from 'react';

import { useParams } from 'react-router-dom';

import { AppContext } from '../scripts/context'

import PayPalButton from './paypalButton';

export default function Header() {

	const {
	//GENERAL
		backendUrl,
	//CHECKOUT PANEL
		exRateChfUsdRef,
		cartItemLimitRef,
		cartContent,
		setCartContent,
		checkoutPanelState,
		checkoutPanelContentState,
		setCheckoutPanelContentState,
		checkoutPanelCountryState,
		setCheckoutPanelCountryState,
		paypalSuccessState,
		shippingCostState,
		setShippingCostState,
		cartDutyState,
		setCartDutyState,
		handleCheckoutPanel,
	//STYLE
        checkoutContainerStyleState,
		checkoutPanelStyleState,
		checkoutPanelCountryOverlayStyleState
    } = useContext(AppContext);

	const [countryButtonFillState, setCountryButtonFillState] = useState("#00000066");
	const [checkoutPanelCountryPanelState, setCheckoutPanelCountryPanelState] = useState(false);
	const [cartTotalState, setCartTotalState] = useState(0);
	const [shippingDaysState, setShippingDaysState] = useState(0);
  	const [error, setError] = useState(null);

	const checkoutPanelRef = useRef();
	const shippingCountriesRef = useRef([]);
	const paypalOrderIdRef = useRef();

  	// Fetch shipping data with localStorage caching
  	// Response format: [{ iso_code, country_name, package_type, weight_grams, price_chf, delivery_days }, ...]
  	const fetchShippingPrices = async () => {
  	  	const KEY = 'shipping_data'
  	  	const TTL = 60 * 1000; // 1 mintue (for testing), change to 15 minutes or more in production
  	  	try {
  	    	const cached = localStorage.getItem(KEY);
  	    	if (cached) {
  	      		const parsed = JSON.parse(cached);
  	      		if (Date.now() - parsed.ts < TTL && Array.isArray(parsed.data)) {
  	        		shippingCountriesRef.current = parsed.data;
  	        		return parsed.data;
  	      		};
  	    	};

  	    	const url = `${backendUrl}/api/shipping`;
  	    	const response = await fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
  	    	if (!response.ok) throw new Error(`Network response was not ok, status: ${response.status}`);

  	    	const countries = await response.json();
  	    	if (!Array.isArray(countries)) throw new Error('Invalid response from server');

  	    	localStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), data: countries }));
  	    	shippingCountriesRef.current = countries;

  	    	return countries;
  	  	} catch (err) {
  	    	console.error('Failed to fetch shipping estimate:', err.message || err);
  	    	return null;
  	  	};
  	};

	const { page } = useParams();

	function setPaypalOrderIdRef(id) {
		paypalOrderIdRef.current = id;
	};

	function cartContentUpdate(cartContentTemp) {

		let cartContentHasChanged = false;

		if (cartContentTemp.length !== cartContent.length) {

			cartContentHasChanged = true;

		} else if (cartContentTemp.length > 0 && cartContent.length > 0) {

			for (let index = 0; index <= cartContentTemp.length - 1; index++) {

				if (cartContentTemp[index].count !== cartContent[index].count) {

					cartContentHasChanged = true;
					break;

				};

			};

		}

		if (cartContentTemp.length === 0) {

			handleCheckoutPanel(false, true);

		} else if (cartContentHasChanged === true) {

			setCartContent(cartContentTemp);
			localStorage.setItem("cartContent", JSON.stringify(cartContentTemp));
			calculatePrice();

		};

	};

	function handleQuantityMinusClick(indexClick) {

		let cartContentTemp = JSON.parse(localStorage.getItem("cartContent"));

		cartContentTemp.forEach((item, index) => {

            if (index === indexClick) {

                item.count = Math.max(item.count - 1, 0);

				if (item.count === 0) {

					cartContentTemp.splice(index, 1);

				};

            };

        });

		cartContentUpdate(cartContentTemp);

	};

	function handleQuantityPlusClick(indexClick) {

		let cartContentTemp = JSON.parse(localStorage.getItem("cartContent"));

		cartContentTemp.forEach((item, index) => {

            if (index === indexClick) {

                item.count = Math.min(item.count + 1, cartItemLimitRef.current);

            };

        });

		cartContentUpdate(cartContentTemp);

	};

	function handleCountryButtonClick() {
		if(checkoutPanelCountryPanelState === false) {
			setCheckoutPanelCountryPanelState(true);
		} else if (checkoutPanelCountryPanelState === true) {
			setCheckoutPanelCountryPanelState(false);
		};
	};

	function handleCheckoutPanelClick() {
		if (checkoutPanelCountryPanelState === true) {
			setCheckoutPanelCountryPanelState(false);
		};
	};

	function getPddpFee(countryName, cartTotal) {

		if (countryName === "United States") {

			return 0.02 * cartTotal + 10

		} else {

			return 0

		};

	};

	function getDutyRate(countryName, itemClass) {

		if (countryName === "United States" && itemClass === "3919.90.50.60") { // 3919.90.50.60 - Self-adhesive plastic sheets, film, tape, or stickers

			return 0.058

		} else {

			return 0

		};

	};

	function getPackingWeight(format) {

		if (format === "c5") {

			return 10

		} else if (format === "d14") {

			return 15

		};

	};

	function calculatePrice() {

		let cart = { total: 0, subtotal: 0, duty: 0, weight: 0 };
		let packing = { weight: 0, format: "" };
		let shipping = { cost: 0, days: 0, bucket: 0, national: ["Switzerland", "Liechtenstein"].includes(checkoutPanelCountryState), weight: 0  };

	// CART

		if (cartContent && cartContent.length > 0) {

			for (const cartItem of cartContent) {

				const packingWeight = getPackingWeight(cartItem.packing);

				const dutyRate = getDutyRate(checkoutPanelCountryState, cartItem.htsclass);

				cart.subtotal += cartItem.price * cartItem.count;
				cart.duty += cartItem.price * cartItem.count * dutyRate;
				cart.weight += cartItem.weight * cartItem.count;

				if (packingWeight > packing.weight) {

					packing.weight = packingWeight;
					packing.format = cartItem.packing;

				};

			};

		};

	// DUTY

		if (checkoutPanelCountryState !== "select_country") {

			cart.duty += getPddpFee(checkoutPanelCountryState, cart.subtotal);

	// SHIPPING

			const getWeightBucket = (grams, buckets) => buckets.find(b => grams <= b) || buckets[buckets.length - 1];

			const shippingData = shippingCountriesRef.current.find(c => c.country_name === checkoutPanelCountryState);
    		if (shippingData.length === 0) { throw new Error(`No shipping data for county name: ${checkoutPanelCountryState}`) };
			const buckets = shippingData.weights.map(item => item.weight_grams);

			shipping.weight = cart.weight + packing.weight;
			shipping.bucket = shipping.national && packing.format === "d14" ? 1000 : getWeightBucket(shipping.weight, buckets);

			const shippingRow = shippingData.weights.find((item) => item.weight_grams === shipping.bucket);
			if (!shippingRow) { throw new Error(`No shipping row found for weight: ${shipping.bucket}g`) };

			shipping.cost = parseFloat(shippingRow.price_chf);
			shipping.days = parseFloat(shippingRow.delivery_days);

		};

	// TOTAL

		cart.total = cart.subtotal + cart.duty + shipping.cost;

		setShippingCostState(shipping.cost);
		setShippingDaysState(shipping.days);
		setCartDutyState(cart.duty);
		setCartTotalState(cart.total);

	};

	//useEffect on page parameter change
	useEffect(() => {

		handleCheckoutPanel(false, false);
                                                                    // eslint-disable-next-line
    }, [page]);

	//useEffect on cartTotalState and checkoutPanelCountryState change
	useEffect(() => {
		
		if (cartContent && cartContent.length > 0) {

			calculatePrice();

    	};
                                                                    // eslint-disable-next-line
  	}, [cartContent, checkoutPanelCountryState]);

	//useEffect on paypalSuccessState change
	useEffect(() => {

		if (paypalSuccessState === true) {
			setCheckoutPanelContentState("success");
		};
																	// eslint-disable-next-line
	}, [paypalSuccessState]);

	//useEffect on init
	useEffect(() => {
		
		fetchShippingPrices().then(() => {

			calculatePrice();

		});
                                                                    // eslint-disable-next-line
  	}, []);

    return (
        <div id="checkout_container" style={checkoutContainerStyleState}>
			{checkoutPanelState === true ?
                ((() => {
                    if (checkoutPanelContentState === "cart") {
                        return (
							<div id="checkout_panel" style={checkoutPanelStyleState} ref={checkoutPanelRef} onClick = {() => {handleCheckoutPanelClick()}}>
								<div id="checkout_panel_row_margin"></div>
								<div id="checkout_panel_row">
									<div id="checkout_panel_cell_type">product</div>
									<div id="checkout_panel_cell_price">price</div>
									<div id="checkout_panel_cell_count_title">quantity</div>
									<div id="checkout_panel_cell_total">total</div>
                				</div>
								<div id="checkout_panel_row_spacer"></div>
								{
                				    cartContent.map((item, index)=>{
                				        return(
											<div id="checkout_panel_row" key={index}>
												{item.color !== "standard" ?
													<div id="checkout_panel_cell_type">{item.type.replaceAll("njbdesign", "njb design").replaceAll("ammomaker", "ammo maker").replaceAll("birdfeeder", "bird feeder").replaceAll("modelkit", "model kit").replaceAll("_", " ") + " " + item.color}</div>
													: <div id="checkout_panel_cell_type">{item.type.replaceAll("njbdesign", "njb design").replaceAll("ammomaker", "ammo maker").replaceAll("birdfeeder", "bird feeder").replaceAll("modelkit", "model kit").replaceAll("_", " ")}</div>
												}
												<div id="checkout_panel_cell_price">{item.price}</div>
												<div id="checkout_panel_cell_count">
													<svg version="1.1" id="checkout_panel_minus_svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 36 36" pointerEvents="none">
                			                    	    <rect id="checkout_panel_minus_bg" fill="#000000" opacity="0" width="36" height="36" pointerEvents="auto" onClick = {() => {handleQuantityMinusClick(index)}}/>
                			                    	    <rect id="checkout_panel_minus_icon" x="9.647" y="16.807" fill="#FFFFFF" width="16.705" height="2.387"/>
                			                    	</svg>
													{item.count}
													<svg version="1.1" id="checkout_panel_plus_svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 36 36" pointerEvents="none">
                			                    	    <rect id="checkout_panel_plus_bg" fill="#000000" opacity="0" width="36" height="36" pointerEvents="auto" onClick = {() => {handleQuantityPlusClick(index)}}/>
                			                    	    <polygon id="checkout_panel_plus_icon" fill="#FFFFFF" points="26.353,19.193 26.353,16.807 19.193,16.807 19.193,9.647 16.807,9.647 16.808,16.807 9.647,16.807 9.647,19.193 16.807,19.193 16.807,26.353 19.193,26.353 19.193,19.193 "/>
                			                    	</svg>
												</div>
												<div id="checkout_panel_cell_total">{parseFloat((item.price * item.count)).toFixed(2)}</div>
											</div>
                				        )
                				    })
                				}
								<div id="checkout_panel_row_spacer"></div>
								<div id="checkout_panel_row">
									<div id="checkout_panel_cell_type">shipping</div>
									<div id="checkout_panel_cell_country">
										{checkoutPanelCountryPanelState === true ?
											<div id="checkout_panel_country_overlay" style={checkoutPanelCountryOverlayStyleState}>
												{
													shippingCountriesRef.current.map((country, index)=>{
														return(
                            								<div id="checkout_panel_country_overlay_item" key={index} onClick={() => { setCheckoutPanelCountryState(country.country_name) }}>{country.country_name.replaceAll("_", " ")}</div>
														)
													})
												}
											</div>
											: <div 	id="checkout_panel_country_button"
													onClick = {() => {handleCountryButtonClick()}}
													style={{backgroundColor: countryButtonFillState}}
													onPointerDown={() => {setCountryButtonFillState("#66666666")}}
													onTouchStart={() => {setCountryButtonFillState("#66666666")}}
													onPointerUp={() => {setCountryButtonFillState("#00000066")}}
													onPointerLeave={() => {setCountryButtonFillState("#00000066")}}
													onTouchEnd={() => {setCountryButtonFillState("#00000066")}}
											>{checkoutPanelCountryState.replaceAll("_", " ")}</div>
										}
									</div>
									<div id="checkout_panel_cell_total">{parseFloat(shippingCostState).toFixed(2)}</div>
          						</div>
								{checkoutPanelCountryState !== "select_country" ?
									<div id="checkout_panel_row_shipping">
										<div id="checkout_panel_cell_type"></div>
										<div id="checkout_panel_cell_shipping_time">shipping time: ~{shippingDaysState} days</div>
										<div id="checkout_panel_cell_total"></div>
									</div>
									:
									<div id="checkout_panel_row_shipping">
										<div id="checkout_panel_cell_type"></div>
										<div id="checkout_panel_cell_shipping_time"><a href="mailto:store@njb.design">store@njb.design</a> for other regions</div>
										<div id="checkout_panel_cell_total"></div>
									</div>
								}
								{checkoutPanelCountryState === "United States" ?
									<div id="checkout_panel_row">
										<div id="checkout_panel_cell_type">prepaid duty</div>
										<div id="checkout_panel_cell_duty_details">EU to US: 0% - 5.8%<br />PDDP fee: 2% + CHF 10.-</div>
										<div id="checkout_panel_cell_total">{parseFloat(cartDutyState).toFixed(2)}</div>
          							</div>
									:
									null
								}
								<div id="checkout_panel_row_spacer"></div>
								<div id="checkout_panel_row_final_total"><div id="checkout_panel_cell_final_total"><div id="checkout_panel_cell_final_total_usd">{"~USD " + parseFloat(cartTotalState * exRateChfUsdRef.current).toFixed(2)}</div>{"CHF " + parseFloat(cartTotalState).toFixed(2)}</div></div>
								{checkoutPanelCountryState !== "select_country" ?
									<div id="checkout_panel_column_paypal">
										<PayPalButton
                    						country={shippingCountriesRef.current.find(country => country.country_name === checkoutPanelCountryState).iso_code}
											cartContent={cartContent}
											setPaypalOrderIdRef={setPaypalOrderIdRef}
											setError={setError}
										/>
										<div id="checkout_panel_cell_paypal_description">paypal, debit or credit card</div>
										<div id="checkout_panel_cell_paypal_error">{error && <div className="error">{error}</div>}</div>
									</div>
									:
									null
								}
								<div id="checkout_panel_row_margin"></div>
							</div>
                        )
                    } else if (checkoutPanelContentState === "success") {
                        return (
							<div id="checkout_panel" style={checkoutPanelStyleState} ref={checkoutPanelRef} onClick = {() => {handleCheckoutPanelClick()}}>
								<div id="checkout_panel_success">
									<div id="checkout_panel_success_h1">THANK YOU</div>
									<div id="checkout_panel_success_h2">We appreciate your support!</div>
									You will be notified via email as soon as your order is ready for shipping.<br/>If you have any questions please contact us at <a href="mailto:store@njb.design">store@njb.design</a>
									<h2>Order {paypalOrderIdRef.current}</h2>
								</div>
							</div>
                        )
                    }
                })())
				:
				null
			}
        </div>
    )
};